import angular from 'angular';

import * as Configuration from '../../app.constants.js';

export class VerbatimService {
  constructor($http, $q, $translate, $state, AsyncRequestFactory, DropdownItemsFactory) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
    this.$state = $state;
    this.AsyncRequestFactory = AsyncRequestFactory;
    this.DropdownItemsFactory = DropdownItemsFactory;
  }

  getVerbatims(companyId, dateRange, filters){
    return this.$http.get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/verbatim', {params: {
      dateRange: dateRange,
      filters: filters}});
  }

  getTaskView(companyId, taskId){
    const url = `${Configuration.constants.frontendBaseUrl}#/${companyId}/inbox/task/${taskId}`;
    const windowName = `task-${taskId}`;
    window.open(url, windowName);
  }

  formatFromDateForDayRangeQuery(from) {
    return from.getFullYear() + '-' + (from.getMonth() + 1) + '-' + from.getDate() + ' 00:00:00';
  }

  formatToDateForDayRangeQuery(to) {
    return to.getFullYear() + '-' + (to.getMonth() + 1) + '-' + to.getDate() + ' 23:59:59';
  }

  createExport(companyId, data) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/verbatim/exports', data);
  }

  static VerbatimFactory($http, $q, $translate, $state, AsyncRequestFactory, DropdownItemsFactory) {
    return new VerbatimService($http, $q, $translate, $state, AsyncRequestFactory, DropdownItemsFactory);
  }
}

VerbatimService.VerbatimFactory.$inject = ['$http', '$q', '$translate', '$state', 'AsyncRequestFactory', 'DropdownItemsFactory'];
